module.exports = __webpack_public_path__ + "static/img/遵守安全生产法.776b4ea7.jpg";